
export class WebMetricState {
  constructor(
    public readonly launchFrom:string = null
  ) {
  }
}
